import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsTracker"] */ "/app/src/components/AnalyticsTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AudienceSwitcher"] */ "/app/src/components/blocks/AudienceSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GalleryCarouselBlock"] */ "/app/src/components/blocks/GalleryCarouselBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MapBlock"] */ "/app/src/components/blocks/MapBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/blocks/PresentationEffect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TeamPreviewBlock"] */ "/app/src/components/blocks/TeamPreviewBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TestimonialsBlock"] */ "/app/src/components/blocks/TestimonialsBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicFormRenderer"] */ "/app/src/components/forms/PublicFormRenderer.tsx");
